export default __webpack_public_path__ + "static/media/5848200.54711fc4.png";